import { Link } from "react-router-dom";

// =============================================================================
// Official Tick & Pass brand lockup -- served from the original logo artwork
// (background removed, cropped into three transparent PNGs in /public):
//   /brand-mark.png    -- gradient tick-arrow mark alone        (~3.37:1)
//   /brand-lockup.png  -- mark + "TICK & PASS" wordmark          (~2.77:1)
//   /brand-full.png    -- mark + wordmark + tri-colour tagline   (~2.55:1)
// =============================================================================

/** The gradient tick-arrow mark alone. `height` in px. */
export function LogoMark({ height = 24 }) {
  return (
    <img
      src="/brand-mark.png"
      alt="Tick & Pass"
      style={{ height, width: "auto", display: "block", flexShrink: 0 }}
    />
  );
}

/** Mark + wordmark (or full lockup with tagline). `height` in px. */
export function LogoImage({ variant = "lockup", height = 34 }) {
  const src =
    variant === "full"
      ? "/brand-full.png"
      : variant === "mark"
        ? "/brand-mark.png"
        : "/brand-lockup.png";
  return (
    <img
      src={src}
      alt="Tick & Pass"
      style={{ height, width: "auto", display: "block", flexShrink: 0 }}
    />
  );
}

/**
 * Brand lockup, optionally wrapped in a router Link (`to`) and with the
 * tagline underneath (`withTagline` swaps in the full artwork).
 *
 * `mark`/`text` are legacy sizing props from the SVG version -- display
 * height is derived from `mark` so existing call sites keep their scale.
 */
export function BrandLogo({ to = "/", mark = 26, withTagline = false }) {
  const inner = withTagline ? (
    <LogoImage variant="full" height={Math.round(mark * 2.1)} />
  ) : (
    <LogoImage variant="lockup" height={Math.round(mark * 1.55)} />
  );

  if (!to) return inner;
  return (
    <Link to={to} style={{ textDecoration: "none", display: "inline-flex" }}>
      {inner}
    </Link>
  );
}
